// src/contexts/RecipeContext.jsx
import { createContext, useContext, useState, useCallback } from 'react';
import { fetchAllRecipes } from '../services/recipeService';

const RecipeContext = createContext();

export function RecipeProvider({ children }) {
  const [recipes, setRecipes] = useState([]);
  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ useCallback prevents infinite loops when used in useEffect
  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetchAllRecipes();
      setRecipes(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch recipes:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <RecipeContext.Provider value={{
      recipe, setRecipe,
      recipes, setRecipes,
      loading, fetchAll
    }}>
      {children}
    </RecipeContext.Provider>
  );
}

// ✅ You DO want to keep this as a named export
export function useRecipe() {
  const ctx = useContext(RecipeContext);
  if (!ctx) {
    throw new Error("useRecipe must be used within a RecipeProvider");
  }
  return ctx;
}
